import { render } from "./add-password-modal.vue?vue&type=template&id=8cade6a6"
import script from "./add-password-modal.vue?vue&type=script&lang=js"
export * from "./add-password-modal.vue?vue&type=script&lang=js"

import "./add-password-modal.vue?vue&type=style&index=0&id=8cade6a6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__